import { useEffect } from "react"
import { clearSession } from "src/utils/session"

export function useSession() {
    useEffect(() => {
        const handleStorage = (event: StorageEvent) => {
            const clearStore = Number(event.storageArea?.length || 0) === 0
            const hideWindow = document?.visibilityState === "hidden"
            if (clearStore && hideWindow) {
                clearSession()
                window.location.replace("/")
                window.location.reload()
            }
        }

        window.addEventListener("storage", handleStorage)

        return () => {
            window.removeEventListener("storage", handleStorage)
        }
    }, [])
}
